<template>
  <div class="bespread-wrap module-layer1">
    <div class="screen-container">
      <div class="kv-content">
        <img
          src="../../assets/img/layer1/slogan.png"
          alt=""
          srcset=""
          class="kv-slogan"
        />

        <div class="kv-btn">
          <img
            src="../../assets/img/layer1/pay.png"
            alt=""
            srcset=""
            class="pay-btn  cursor"
            @click="handlePay()"
          />
          <img
            src="../../assets/img/layer1/gp.png"
            alt=""
            srcset=""
            class="btn cursor"
              @click="handleGp('gp')"
          />
          <img
            src="../../assets/img/layer1/ios.png"
            alt=""
            srcset=""
            class="btn cursor"
            @click="handleIos('ios')"
          />
          <img
            src="../../assets/img/layer1/apk.png"
            alt=""
            srcset=""
            class="btn cursor"
                @click="handleApk('apk')"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",

  data() {
    return {
      // arrowFlag: true,
      // buiFlag: true
    };
  },
  watch: {},
  created() {},
  methods: {
    handlePay() {
      window.open(`https://lob.ujoygames.com/pay`, "_blank");
    },
    handleIos(val) {
      this.common.goShare(val);
    },
    handleGp(val) {
      this.common.goShare(val);
    },
    handleApk(val) {
      this.common.goShare(val);
    },
    // handleIcon(val) {
    //   if (val == 1) {
    //     alert("等");
    //   } else if (val == 2) {
    //     this.common.goShare("yt");
    //   } else if (val == 3) {
    //     this.common.goShare("fb");
    //   } else if (val == 4) {
    //     this.common.goShare("dc");
    //   }
    // }
  }
};
</script>
<style lang="scss" scoped>
.module-layer1 {
  // pointer-events: none;
  background-image: url("../../assets/img/layer1/bg.png ");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .screen-container {
    width: calc(100% - 250px);
    .kv-content {
      position: absolute;
      bottom: 2vw;
      left: 50%;
      transform: translate(-50%, 0);
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      z-index: 1;
      gap: 0vw;

      .kv-slogan {
        width: auto;
        height: 228px;
      }
      .kv-btn {
        // width: 410px;
        // height: auto;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        gap: 0.6vw;
        .btn {
          height: 80px;
          width: auto;
        }
        .pay-btn {
          height: 126px;
          width: auto;
        }
      }
    }
    .blog {
      position: absolute;
      right: 0;
      top: 2vw;
      display: flex;
      align-items: end;
      flex-direction: column;
      gap: 2vw;
      .share-icon {
        background-image: url("../../assets/img/layer1/share-bg.png");
        width: 291px;
        height: 86px;
        position: relative;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        .iconarrow {
          width: 49px;
          height: 100%;
        }
        .b-icon {
          width: calc(100% - 50px);
          height: 100%;
          position: absolute;
          right: 0;
          display: flex;
          align-items: center;
          gap: 0.5vw;
          img {
            width: 50px;
            height: auto;
          }
        }
      }
      .bui-t {
        width: 339px;
        height: 222px;

        position: relative;
        .buiarrow {
          width: 75px;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
        .bui {
          width: 100%;
          height: auto;
        }
      }
    }
    .bgShow {
      transition: all 0.3s;
    }
    .bgHide {
      transition: all 0.3s;
      margin-right: -13.9vw;
    }
  }
}
@media screen and (max-width: 1200px) {
  .module-layer1 {
    .kv-content {
      bottom: 2vw !important;
    }
  }
}

@media screen and (min-width: 2000px) and (max-width: 2561px) {
  .module-layer1 {
    .kv-content {
      bottom: 3vw !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer1.vue